import MsgApi from './msg-api.js';

// Default options for the plugin.
const DEFAULTS = {
  messages: {
    ad_yes: {
      event: 'vast.adResponseEndNoErr'
    },
    ad_no: {
      event: 'vast.adNotProvided'
    },
    ad_start: {
      event: 'vast.adStart' 
    },
    ad_imp: {
      event: 'vast.trackImpressions'
    },
    ad_click: {
      event: 'vast.trackClick'
    },
    ad_end: {
      event: 'vast.adComplete'
    },
    content_start: {
      event: 'vast.contentStart'
    },
    content_end: {
      event: 'vast.contentEnd'
    }
  },
  prefix: 'ktvr_'
};

/**
 * The base Stat class to extend from. Sends nothing. Aggregates StatEmitter and utils methods.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatEmitter
 */

class MsgKtvr extends MsgApi {
  constructor(player, options) {
    let options_ = Object.assign({}, DEFAULTS, options);
    super(player, options_);
  }

  getMsgData(evInfo = {}) {
    return this.prefix + evInfo.type;
  }
}

export default MsgKtvr;
